"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function () {
  var ownKeys = function (o) {
    ownKeys = Object.getOwnPropertyNames || function (o) {
      var ar = [];
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
      return ar;
    };
    return ownKeys(o);
  };
  return function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseButton = exports.Divider = exports.ContainerMain = exports.ContainerBase = exports.ContainerHeader = exports.Container = exports.Wrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const animations = {
  appear: {
    right: (0, styled_components_1.keyframes)`
      from {
        transform: translate(100%, 0);
      
      }
      to {
        transform: translate(0, 0);
      }
    `,
    top: (0, styled_components_1.keyframes)`
      from {
        transform: translate(0, -100%);
      
      }
      to {
        transform: translate(0, 0);
      }
    `,
    bottom: (0, styled_components_1.keyframes)`
      from {
        transform: translate(0, 100%);
      
      }
      to {
        transform: translate(0, 0);
      }
    `,
    left: (0, styled_components_1.keyframes)`
    from {
        transform: translate(-100%, 0);
      
      }
      to {
        transform: translate(0, 0);
      }
    `
  },
  disappear: {
    right: (0, styled_components_1.keyframes)`
      from {
        transform: translate(0, 0);
      }
      to {
        transform: translate(100%, 0);
      }
    `,
    top: (0, styled_components_1.keyframes)`
      from {
        transform: translate(0, 0);
      
      }
      to {
        transform: translate(0, -100%);
      }
    `,
    bottom: (0, styled_components_1.keyframes)`
      from {
        transform: translate(0, 0);
      
      }
      to {
        transform: translate(0, 100%);
      }
    `,
    left: (0, styled_components_1.keyframes)`
      from {
        transform: translate(0, 0);
      }
      to {
        transform: translate(-100%, 0);
      }`
  }
};
exports.Wrapper = styled_components_1.default.section`
  ${props => (0, styled_components_1.css)`
    width: ${props.width};
    max-width: ${props.width};
    min-width: ${props.width};
  `}
  position: fixed;
  padding: 20px 30px;
  background-color: ${props => props.theme.colors.white};
  box-shadow: 0 0 5px #0000001a;
  box-sizing: border-box;
  transition: transform 0.2s;
  animation: 0.2s ease-in forwards;

  * {
    box-sizing: border-box;
  }

  ${props => {
  if (props.anchor === 'right') {
    return (0, styled_components_1.css)`
        transform: translate(100%, 0);
        right: 0;
        top: 0;
        bottom: 0;
      `;
  }
}}

  ${props => {
  if (props.anchor === 'left') {
    return (0, styled_components_1.css)`
        transform: translate(-100%, 0);
        left: 0;
        top: 0;
        bottom: 0;
      `;
  }
}}

  ${props => {
  if (props.anchor === 'bottom') {
    return (0, styled_components_1.css)`
        transform: translate(0, 100%);
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
      `;
  }
}}

  ${props => {
  if (props.anchor === 'top') {
    return (0, styled_components_1.css)`
        transform: translate(0, -100%);
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
      `;
  }
}}

  ${props => props.isOpen ? (0, styled_components_1.css)`
          animation-name: ${animations.appear[props.anchor]};
        ` : (0, styled_components_1.css)`
          animation-name: ${animations.disappear[props.anchor]};
        `}

  ${props => props.stylesOverride};
`;
exports.Container = styled_components_1.default.div.attrs({
  className: 'drawer-container'
})`
  min-height: 100%;
`;
exports.ContainerHeader = styled_components_1.default.header.attrs({
  className: 'drawer-container--header'
})``;
exports.ContainerBase = styled_components_1.default.main`
  margin-right: -15px;
  padding-right: 10px;
  overflow-y: auto;
`;
exports.ContainerMain = (0, styled_components_1.default)(exports.ContainerBase).attrs({
  className: 'drawer-container--main'
})`
  ${props => (0, styled_components_1.css)`
    height: ${props.maxHeight}px;
    max-height: ${props.maxHeight}px;
  `}
`;
exports.Divider = styled_components_1.default.hr`
  height: 5px;
  outline: 0;
  border: 0;
  margin: 30px -30px 0;
  box-shadow: 0 1px 1px 0 #0000001a;
`;
exports.CloseButton = styled_components_1.default.button.attrs({
  type: 'button',
  name: 'close',
  className: 'drawer-close-btn'
})`
  height: 24px;
  width: 24px;
  border: 0;
  outline: 0;
  background: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.colors.gray_602};
  position: absolute;
  cursor: pointer;
  transition: color 0.2s;
  right: 18px;
  top: 17px;

  &:hover,
  &:focus {
    color: ${props => props.theme.colors.primary_700_main};
  }
`;